import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { HomeProductSection } from '../home-product/HomeProductSection'

import soundscapeLogo from 'shared/assets/logos/soundscape.svg'
import speakerIcon from '../home-product/assets/speaker.svg'
import multizoneIcon from '../home-product/assets/multizone.svg'
import settingsIcon from 'shared/assets/icons/settings-sliders.svg'
import soundscapeDesktopBg from '../home-product/assets/product-feature-display-soundscape-desktop-bg.jpeg'
import soundscapeMobileBg from '../home-product/assets/product-feature-display-soundscape-mobile-bg.jpeg'

export const SoundscapeSection: React.FC = () => {
  const navigate = useNavigate()

  const handleSoundscapeClick = () => {
    navigate('/soundscape')
  }

  return (
    <HomeProductSection
      logoUrl={soundscapeLogo}
      text="Transform existing vehicle GPUs into powerful audio processors using a fraction of GPU capacity to deliver differentiating, system-wide features"
      buttonText="Explore Soundscape"
      onButtonClick={handleSoundscapeClick}
      desktopBackgroundUrl={soundscapeDesktopBg}
      mobileBackgroundUrl={soundscapeMobileBg}
      featureCards={[
        {
          icon: speakerIcon,
          text: "Enable Real-Time Acoustic Tuning"
        },
        {
          icon: multizoneIcon,
          text: "Differentiate with True Multizone Playback"
        },
        {
          icon: settingsIcon,
          text: "Unlock Advanced Audio Features"
        }
      ]}
    />
  )
}